import { useTranslation } from 'next-i18next'
import { Box, ButtonLink, IconGift } from '@machobear/design-system'

export const BlackFridayMobileNavButton = () => {
  const { t } = useTranslation()

  return (
    <Box padding="small" width="full">
      <ButtonLink
        tone="neutral"
        variant="solid"
        size="standard"
        href="/landlords/promotions"
        id="bf-mobile-nav-button"
      >
        <IconGift tone="critical" /> {t('HOLIDAY DEALS')}
      </ButtonLink>
    </Box>
  )
}
